import { createSelector } from '@reduxjs/toolkit'

const getArcAdsState = (state) => state.arcAds

export const getArcAds = createSelector(
  getArcAdsState,
  (state) => {
    return state.sortedIds.map((id) => state.entities[id])
  }
)

export const getIncludedData = createSelector(
  getArcAdsState,
  (state) => state.included || []
)

export const getArcAdById = createSelector(
  getArcAdsState,
  (state) => (id) => state.entities[id]
)

export const getSelectedAd = createSelector(
  getArcAdsState,
  (state) => state.selectedAd
)

export const getSources = createSelector(
  getArcAdsState,
  (state) => state.sources
)

export const getIsSourcesLoaded = createSelector(
  getArcAdsState,
  (state) => state.isSourcesLoaded
)

export const getIsLoaded = createSelector(
  getArcAdsState,
  (state) => state.isLoaded
)

export const getIsSavingActive = createSelector(
  getArcAdsState,
  (state) => state.isSavingActive
)

export const getPage = createSelector(
  getArcAdsState,
  (state) => state.page
)

export const getPageCount = createSelector(
  getArcAdsState,
  (state) => state.pageCount
)

export const getSearchString = createSelector(
  getArcAdsState,
  (state) => state.search
)

export const getFilters = createSelector(
  getArcAdsState,
  (state) => state.filters
)

export const getSorter = createSelector(
  getArcAdsState,
  (state) => state.sorter
)

export const getImagePreview = createSelector(
  getArcAdsState,
  (state) => state.imagePreview
)

export const getIconPreview = createSelector(
  getImagePreview,
  (imagePreview) => imagePreview.icon
)

export const getHeroPreview = createSelector(
  getImagePreview,
  (imagePreview) => imagePreview.hero
)

export const getIsDataFilteredOrSorted = createSelector(
  [getFilters, getSorter, getSearchString],
  (filters, sorter, search) => {
    return !!(
      Object.keys(filters).length ||
      Object.keys(sorter).length ||
      search
    )
  }
)